import type { SemanticCOLORS } from 'semantic-ui-react';
import { COULEURS_INITIALES } from './utilisateur';

// Valeurs hexadecimales officielles de la palette Semantic UI : EtiquettesInput
// (finances-utils) attend un tableau de couleurs CSS et non des noms semantiques
const HEX_PAR_COULEUR_SEMANTIC: Record<SemanticCOLORS, string> = {
	black: '#1b1c1d',
	blue: '#2185d0',
	brown: '#a5673f',
	green: '#21ba45',
	grey: '#767676',
	olive: '#b5cc18',
	orange: '#f2711c',
	pink: '#e03997',
	purple: '#a333c8',
	red: '#db2828',
	teal: '#00b5ad',
	violet: '#6435c9',
	yellow: '#fbbd08',
};

// Meme palette (et meme ordre) que COULEURS_INITIALES dans utilisateur.ts
export const COULEURS_ETIQUETTES = COULEURS_INITIALES.map(
	(couleur) => HEX_PAR_COULEUR_SEMANTIC[couleur],
);

// Couleur deterministe d'une categorie d'idee Vision 360 : une meme categorie
// a toujours la meme teinte, dans la palette des etiquettes des demandes
export const getCouleurCategorie = (libelle: string): SemanticCOLORS => {
	let hash = 0;
	for (const caractere of libelle) {
		hash = (hash * 31 + caractere.charCodeAt(0)) | 0;
	}
	return COULEURS_INITIALES[Math.abs(hash) % COULEURS_INITIALES.length];
};
